import React from "react"
import {Spin} from "antd"
import {LoadingOutlined} from "@ant-design/icons"
import {isMobile} from "react-device-detect"

function PageLoader() {
    return (
        <div className="spin-loader">
            <Spin indicator={<LoadingOutlined style={{fontSize: isMobile ? 42 : 64}} spin/>}/>
        </div>
    )
}

export default PageLoader
